import { message, Select } from "antd";
import { ErrorMessages, ESubmittalStatus } from "constants/index";
import { IntegrationType } from "pages/subscription-settings/integrations-tab-new/utils";
import { useEffect, useMemo, useState } from "react";
import { getSubmittalStatus } from "utils/utils";

export default function FeatureSubmittalRevision(props: {
  featureInstanceData: any;
  localFeatureInstanceData: any;
  setLocalFeatureInstanceData: any;
  submittal: any;
  projectIntegrationConfig: any;
  isIntegrationMode: boolean;
  setRevisionMode: any;
  submittalHeaderMap: any;
  tokenContents: any;
  setSubmittalViewState: any;
}) {
  const {
    featureInstanceData,
    localFeatureInstanceData,
    setLocalFeatureInstanceData,
    submittal,
    projectIntegrationConfig,
    isIntegrationMode,
    setRevisionMode,
    submittalHeaderMap,
    tokenContents,
    setSubmittalViewState
  } = props;
  const [submittalRevisions, setSubmittalRevision] = useState<Array<any>>([]);
  const [currentRevision, setCurrentRevision] = useState(null);
  const revisionSelectHidden = useMemo(() => {
    return (
      isIntegrationMode &&
      projectIntegrationConfig &&
      projectIntegrationConfig.length &&
      projectIntegrationConfig[0].integration.system ===
        IntegrationType[IntegrationType.AUTODESK]
    );
  }, [isIntegrationMode, projectIntegrationConfig]);

  useEffect(() => {
    if (featureInstanceData?.feature_instance_revisions) {
      const clonedSubmittalRevisions = [
        ...featureInstanceData.feature_instance_revisions
      ];
      clonedSubmittalRevisions.sort(
        (a: any, b: any) => b.revision - a.revision
      );
      setSubmittalRevision(clonedSubmittalRevisions);
    } else {
      setSubmittalRevision([]);
    }
  }, [featureInstanceData]);

  useEffect(() => {
    if (currentRevision !== localFeatureInstanceData?.revision) {
      setCurrentRevision(localFeatureInstanceData?.revision);
    }
  }, [
    currentRevision,
    featureInstanceData?.revision,
    localFeatureInstanceData?.revision
  ]);

  return !revisionSelectHidden && submittalRevisions.length ? (
    <div>
      <Select
        style={{ width: 150 }}
        value={currentRevision}
        onChange={(val: any) => {
          setCurrentRevision(val);
          if (val === featureInstanceData?.revision) {
            setRevisionMode(false);
            setLocalFeatureInstanceData(featureInstanceData);
            const submittalStatus = getSubmittalStatus(
              submittal?.submittal_status_history_details
            );
            setSubmittalViewState({
              userType: tokenContents!.userType,
              status: submittalStatus || ESubmittalStatus.CREATE
            });
          } else {
            const revision: any = submittalRevisions?.find(
              (x) => x.revision === val
            );
            if (revision) {
              setRevisionMode(true);
              const revisionData = { ...revision?.data };
              revisionData.revision = val;
              setLocalFeatureInstanceData(revisionData);

              const submittalStatus = getSubmittalStatus(
                revision?.submittal_status_history_details
              );
              setSubmittalViewState({
                userType: tokenContents!.userType,
                status: submittalStatus || ESubmittalStatus.CREATE
              });
              message.warn(ErrorMessages.RevisionMode);
            }
          }
        }}
        options={[
          {
            value: featureInstanceData?.revision,
            label: `${submittalHeaderMap?.revision}: ${
              featureInstanceData?.revision || "0"
            }`
          },
          ...submittalRevisions.map((x) => {
            return {
              value: x?.revision,
              label: `${submittalHeaderMap?.revision}: ${x?.revision || ""}`
            };
          })
        ]}
      />
    </div>
  ) : null;
}
